export {
  default as shadedArea,
  ReactComponent as ShadedArea,
} from '@assets/icons/features-and-amenities/shaded-area.svg'    
